<template>
  <div
    v-if="isOpen"
    id="devbox"
    class="devbox"
    :style="boxPosition"
  >
    <div
      class="drag-bar"
      @mouseup="toggleIsDragging"
      @mousedown.self="toggleIsDragging"
    >
      <button class="close" @click="close">
        X
      </button>
    </div>
    <div class="content">
      <strong class="title">DevBox</strong>
      <ul class="components">
        <li v-for="component in components" :key="component.name">
          <component :is="component" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'DevBox',

  data () {
    return {
      position: { x: -1, y: -1 },
      isDragging: false,
      keyBuffer: [],
      debouncedClearKeyBuffer: debounce(this.clearKeyBuffer, 1000)
    }
  },

  computed: {
    state () {
      return this.$devBox.state
    },

    isOpen () {
      return this.state.isOpen
    },

    components () {
      return this.state.components
    },

    boxPosition () {
      return {
        left: `${this.position.x}px`,
        top: `${this.position.y}px`
      }
    }
  },

  mounted () {
    document.addEventListener('keydown', this.listenForActivation)
    window.openDevBox = this.open
  },

  beforeDestroy () {
    document.removeEventListener('keydown', this.listenForActivation)
    this.close()
    delete window.openDevBox
  },

  methods: {
    open () {
      this.$devBox.open()
      document.addEventListener('mousemove', this.setPosition)
    },

    close () {
      this.$devBox.close()
      document.removeEventListener('mousemove', this.setPosition)
    },

    listenForActivation ({ key }) {
      this.keyBuffer.push(key)

      if (this.keyBuffer.join('') === 'iamdev') this.open()

      this.debouncedClearKeyBuffer()
    },

    clearKeyBuffer () {
      this.keyBuffer = []
    },

    toggleIsDragging ({ type }) {
      if (type === 'mousedown') {
        this.isDragging = true
      } else if (type === 'mouseup') {
        this.isDragging = false
      }
    },

    setPosition ({ clientX, clientY }) {
      if (!this.isDragging) return

      this.position = { x: clientX * 0.99, y: clientY * 0.99 }
    }
  }
}
</script>

<style lang="scss" scoped>
.devbox {
  background: $bionic-cyan;
  border: 1px solid $bionic-navy;
  left: $spacing-20;
  position: fixed;
  top: $spacing-20;
  z-index: 1000;
}

.drag-bar {
  background: $bionic-yellow;
  width: 100%;
  display: inline-block;
  padding: $spacing-8;
}

.title {
  display: block;
  padding-bottom: $spacing-16;
}

.content {
  padding: 0 $spacing-20 $spacing-20;
}

.close {
  font-size: 16px;
}

.components {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
